document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gw-home]').forEach((home) => {
    const slides = [...home.querySelectorAll('[data-slide]')];
    const current = home.querySelector('[data-current]');
    const dots = home.querySelector('[data-dots]');
    let index = 0;

    const show = (next) => {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      if (dots) [...dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    if (dots) slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show arrival ${i + 1}`);
      dot.addEventListener('click', () => show(i));
      dots.append(dot);
    });
    home.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
    home.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
    show(0);

    const rail = home.querySelector('[data-product-rail]');
    const scrollRail = (direction) => rail?.scrollBy({ left: direction * Math.min(rail.clientWidth * 0.82, 520), behavior: 'smooth' });
    home.querySelector('[data-rail-prev]')?.addEventListener('click', () => scrollRail(-1));
    home.querySelector('[data-rail-next]')?.addEventListener('click', () => scrollRail(1));
  });

  document.querySelectorAll('.gw-menu-button').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (menu) menu.hidden = open;
    });
  });

  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const selectedLabel = select.options[select.selectedIndex]?.textContent?.trim() || 'the selected order';
      const status = select.form?.querySelector('[data-sort-status]');
      if (status) status.textContent = `Sorting products by ${selectedLabel}.`;
      select.setAttribute('aria-busy', 'true');
      window.setTimeout(() => select.form?.requestSubmit(), 120);
    });
  });

  document.querySelectorAll('[data-filter-tabs]').forEach((tabs) => {
    const active = tabs.querySelector('.is-active');
    if (active) tabs.scrollLeft = Math.max(0, active.offsetLeft - (tabs.clientWidth - active.clientWidth) / 2);
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const panels = [...gallery.querySelectorAll('[data-media-panel]')];
    const thumbs = [...gallery.querySelectorAll('[data-media-thumb]')];
    const current = gallery.querySelector('[data-gallery-current]');
    const main = gallery.querySelector('.gw-pdp-gallery__main');
    let swipeStart = null;

    const showMedia = (nextIndex) => {
      if (!panels.length) return;
      const index = (nextIndex + panels.length) % panels.length;
      const activeId = panels[index].dataset.mediaPanel;

      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaThumb === activeId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
    };

    const activeIndex = () => Math.max(0, panels.findIndex((panel) => panel.classList.contains('is-active')));

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const index = panels.findIndex((panel) => panel.dataset.mediaPanel === thumb.dataset.mediaThumb);
      if (index >= 0) showMedia(index);
    }));

    main?.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      swipeStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    });

    main?.addEventListener('pointerup', (event) => {
      if (!swipeStart || event.pointerId !== swipeStart.id) return;
      const deltaX = event.clientX - swipeStart.x;
      const deltaY = event.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
      showMedia(activeIndex() + (deltaX < 0 ? 1 : -1));
    });

    main?.addEventListener('pointercancel', () => { swipeStart = null; });

    main?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showMedia(activeIndex() + (event.key === 'ArrowRight' ? 1 : -1));
    });
  });

  document.querySelectorAll('[data-gw-product]').forEach((product) => {
    const variant = product.querySelector('[data-product-variant]');
    const price = product.querySelector('[data-product-price] strong');
    const compare = product.querySelector('[data-product-price] s');
    const stock = product.querySelector('[data-product-stock]');
    const stockLabel = product.querySelector('[data-stock-label]');
    const availabilityLabel = product.querySelector('[data-availability-label]');
    const badge = product.querySelector('[data-product-badge]');
    const preorderNotice = product.querySelector('[data-preorder-notice]');
    const preorderDispatch = product.querySelector('[data-preorder-dispatch]');
    const preorderNote = product.querySelector('[data-preorder-note]');
    const preorderProperty = product.querySelector('[data-preorder-property]');
    const preorderDispatchProperty = product.querySelector('[data-preorder-dispatch-property]');
    const preorderNoteProperty = product.querySelector('[data-preorder-note-property]');
    const submit = product.querySelector('[data-product-submit]');
    const submitLabel = product.querySelector('[data-submit-label]');
    const submitPrice = product.querySelector('[data-submit-price]');
    if (!variant) return;

    variant.addEventListener('change', () => {
      const option = variant.selectedOptions[0];
      const available = option?.dataset.available === 'true';
      const preorder = option?.dataset.preorder === 'true';
      const dispatch = option?.dataset.dispatch || '';
      const note = option?.dataset.preorderNote || '';
      const stateLabel = preorder ? (available ? 'PRE-ORDER' : 'PRE-ORDER CLOSED') : (available ? 'IN STOCK' : 'SOLD OUT');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option?.dataset.compare || '';
        compare.hidden = !option?.dataset.compare;
      }
      if (submit) submit.disabled = !available;
      if (submitLabel) submitLabel.textContent = preorder ? (available ? 'PRE-ORDER' : 'PRE-ORDER CLOSED') : (available ? 'ADD TO PIT BAG' : 'SOLD OUT');
      if (submitPrice && option?.dataset.price) submitPrice.textContent = option.dataset.price;
      if (stock) {
        stock.classList.toggle('is-sold-out', !available);
        stock.classList.toggle('is-preorder', preorder);
      }
      if (stockLabel) stockLabel.textContent = stateLabel;
      if (availabilityLabel) availabilityLabel.textContent = stateLabel;
      if (badge) badge.textContent = preorder ? 'PRE-ORDER' : (badge.dataset.defaultBadge || 'PACK PICK');
      if (preorderNotice) preorderNotice.hidden = !preorder;
      if (preorderDispatch) preorderDispatch.textContent = dispatch ? `Expected dispatch: ${dispatch}.` : 'The dispatch window is being confirmed.';
      if (preorderNote) {
        preorderNote.textContent = note;
        preorderNote.hidden = !note;
      }
      if (preorderProperty) preorderProperty.disabled = !preorder;
      if (preorderDispatchProperty) {
        preorderDispatchProperty.value = dispatch;
        preorderDispatchProperty.disabled = !preorder || !dispatch;
      }
      if (preorderNoteProperty) {
        preorderNoteProperty.value = note;
        preorderNoteProperty.disabled = !preorder || !note;
      }
      if (option?.dataset.variantUrl) window.history.replaceState({}, '', option.dataset.variantUrl);
      if (option?.dataset.media) product.querySelector(`[data-media-thumb="${option.dataset.media}"]`)?.click();
    });
  });

  document.querySelectorAll('[data-product-share]').forEach((share) => {
    const nativeButton = share.querySelector('[data-share-native]');
    const copyButton = share.querySelector('[data-share-copy]');
    const status = share.querySelector('[data-share-status]');
    const title = share.dataset.shareTitle || document.title;
    const url = share.dataset.shareUrl || window.location.href;

    const copyLink = async () => {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = url;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.append(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
        }
        if (status) status.textContent = 'PRODUCT LINK COPIED.';
      } catch {
        if (status) status.textContent = 'COPY FAILED. USE THE ADDRESS BAR LINK.';
      }
    };

    if (typeof navigator.share !== 'function') nativeButton?.setAttribute('hidden', '');
    nativeButton?.addEventListener('click', async () => {
      try {
        await navigator.share({ title, url });
        if (status) status.textContent = 'PRODUCT SHARED.';
      } catch (error) {
        if (error?.name !== 'AbortError') await copyLink();
      }
    });
    copyButton?.addEventListener('click', copyLink);
  });
});
